module.exports = __webpack_public_path__ + "assets/images/EUR50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR50.png
// module id = 1369
// module chunks = 1